import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Input,
  //Table,
  Spinner,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import ButtonSpinner from "components/ButtonSpinner"
import * as productAction from "../../../store/cHJvZHVjdFN0YXR1c0/actions"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
import moment from "moment"
import { MultiSelect } from "react-multi-select-component"
import api from "helpers/Api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ReactDOM from "react-dom"
import ProductAgingTableComponent from "./ProductAgingTableComponent"

const ProductStatusAgingReport = (props) => {
  const { searchBtnStyle, dispatch } = props

  const title = "Product Status Aging Report"

  //productAction
  const [productStatusData, setProductStatusData] = useState({
    eventFromDate: "",
    eventToDate: "",
  })
  //Fetching API
  useEffect(() => {
    dispatch(productAction.loadProductStatus())
    dispatch(productAction.loadRecordsMetaData())
  }, [])
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  //date format
  const update = useSelector(
    (specificstate) => specificstate.productStatusAgingReport
  )
  //product_data
  const { product_data = [], recordsMetaData = {} } = update
  const productCategoryOptions = !isEmpty(recordsMetaData)
    ? recordsMetaData.productCategoryOptions
    : []
  const [productCategory, setProductCategory] = useState([])

  //Handle Change

  const [employee, setEmployee] = useState([])

  const handleChange = (e) => {
    setProductStatusData({
      ...productStatusData,
      [e.target.name]: e.target.value,
    })
  }

  const [downloadLoading, setDownloadLoading] = useState(false)
  //Search value
  const employees = !isEmpty(employee) && employee.map((m) => m.value)
  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const [btnLoader, setBtnLoader] = useState(false)
  const [searchValue, setSearchValue] = useState({})
  const products = productCategory && productCategory.map((m) => m.value)
  const handleFilter = (e) => {
    e.preventDefault()

    var searchEmployee = employee && employee ? employees : ""
    var searchProduct =
      !isEmpty(productCategory) && productCategory ? products : ""
    var searchFromDate =
      productStatusData && productStatusData.eventFromDate
        ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      productStatusData && productStatusData.eventToDate
        ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}

    if (searchProduct) {
      searchvalue.ProductCategoryId = searchProduct
    }
    if (searchEmployee) {
      searchvalue.CRMEmpId = searchEmployee
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    setSearchValue(searchvalue)
    dispatch(productAction.loadProductStatus(searchvalue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 3000)
  }

  //reset

  const resetForm = () => {
    setEmployee([])
    setSearchInput("")
    setSearchValue({})
    setProductCategory([])
    setProductStatusData({
      ...productStatusData,
      eventFromDate: "",
      eventToDate: "",
    })
    dispatch(productAction.loadProductStatus())
  }

  const productStatusTable =
    !isEmpty(product_data) && product_data.length > 0
      ? product_data.map((data, index) => {
        const PLPending =
          data && !isEmpty(data.data) && data.data.length > 0
            ? data.data.filter(
              (data) => data.productioProcessStatusName == "PENDING PL"
            )
            : []
        const plPendingValue = !isEmpty(PLPending)
          ? PLPending.map((date) => {
            const dateValue = date.assignCrmEmployeeStartDate
              ? moment(date.assignCrmEmployeeStartDate).format(dateFormat)
              : ""
            const count = date.CountOfassignCrmEmployeeDate
              ? date.CountOfassignCrmEmployeeDate
              : ""
            const separator = dateValue !== "" && count !== "" ? " - " : ""
            const result = `${dateValue}${separator}${count}`
            return dateValue !== "" || count !== "" ? result : "--"
          })
          : "--"

        const EWPending =
          data && !isEmpty(data.data) && data.data.length > 0
            ? data.data.filter(
              (data) => data.productioProcessStatusName == "EW PENDING"
            )
            : []
        const ewPendingValue = !isEmpty(EWPending)
          ? EWPending.map((date) => {
            const dateValue = date.assignedTeamleadStartDate
              ? moment(date.assignedTeamleadStartDate).format(dateFormat)
              : ""
            const count = date.CountOfassignedTeamleadDate
              ? date.CountOfassignedTeamleadDate
              : ""
            const separator = dateValue !== "" && count !== "" ? " - " : ""
            const result = `${dateValue}${separator}${count}`
            return dateValue !== "" || count !== "" ? result : "--"
          })
          : "--"

        const EWQueue =
          data && !isEmpty(data.data) && data.data.length > 0
            ? data.data.filter(
              (data) => data.productioProcessStatusName == "EW QUEUE"
            )
            : []
        const ewQueueValue = !isEmpty(EWQueue)
          ? EWQueue.map((date) => {
            const dateValue = date.assignEmployeeStartDate
              ? moment(date.assignEmployeeStartDate).format(dateFormat)
              : ""
            const count = date.CountOfAssignEmployeeDate
              ? date.CountOfAssignEmployeeDate
              : ""
            const separator = dateValue !== "" && count !== "" ? " - " : ""
            const result = `${dateValue}${separator}${count}`
            return dateValue !== "" || count !== "" ? result : "--"
          })
          : "--"

        const EWInprogress =
          data && !isEmpty(data.data) && data.data.length > 0
            ? data.data.filter(
              (data) => data.productioProcessStatusName == "EW INPROGRESS"
            )
            : []
        const ewInProgressValue = !isEmpty(EWInprogress)
          ? EWInprogress.map((date) => {
            const dateValue = date.subStatusStartDate
              ? moment(date.subStatusStartDate).format(dateFormat)
              : ""
            const count = date.CountOfsubStatuseDate
              ? date.CountOfsubStatuseDate
              : ""
            const separator = dateValue !== "" && count !== "" ? " - " : ""
            const result = `${dateValue}${separator}${count}`
            return dateValue !== "" || count !== "" ? result : "--"
          })
          : "--"

        const EWCompleted =
          data && !isEmpty(data.data) && data.data.length > 0
            ? data.data.filter(
              (data) => data.productioProcessStatusName == "EW COMPLETED"
            )
            : []
        const ewCompletedValue = !isEmpty(EWCompleted)
          ? EWCompleted.map((date) => {
            const dateValue = date.operationHistoryStartDate
              ? moment(date.operationHistoryStartDate).format(dateFormat)
              : ""
            const count = date.CountOfoperationHistory
              ? date.CountOfoperationHistory
              : ""
            const separator = dateValue !== "" && count !== "" ? " - " : ""
            const result = `${dateValue}${separator}${count}`
            return dateValue !== "" || count !== "" ? result : "--"
          })
          : "--"

        const pendingToShare =
          data && !isEmpty(data.data) && data.data.length > 0
            ? data.data.filter(
              (data) => data.productioProcessStatusName == "EW QC COMPLETED"
            )
            : []
        const pendingToShareValue = !isEmpty(pendingToShare)
          ? pendingToShare.map((date) => {
            const dateValue = date.operationHistoryStartDate
              ? moment(date.operationHistoryStartDate).format(dateFormat)
              : ""
            const count = date.CountOfoperationHistory
              ? date.CountOfoperationHistory
              : ""
            const separator = dateValue !== "" && count !== "" ? " - " : ""
            const result = `${dateValue}${separator}${count}`
            return dateValue !== "" || count !== "" ? result : "--"
          })
          : "--"

        const ewRework =
          data && !isEmpty(data.data) && data.data.length > 0
            ? data.data.filter(
              (data) => data.productioProcessStatusName == "CLIENT REWORK"
            )
            : []
        const ewReworkValue = !isEmpty(ewRework)
          ? ewRework.map((date) => {
            const dateValue = date.operationHistoryStartDate
              ? moment(date.operationHistoryStartDate).format(dateFormat)
              : ""
            const count = date.CountOfoperationHistory
              ? date.CountOfoperationHistory
              : ""
            const separator = dateValue !== "" && count !== "" ? " - " : ""
            const result = `${dateValue}${separator}${count}`
            return dateValue !== "" || count !== "" ? result : "--"
          })
          : "--"

        const ewChanges =
          data && !isEmpty(data.data) && data.data.length > 0
            ? data.data.filter(
              (data) => data.productioProcessStatusName == "CLIENT CHANGES"
            )
            : []
        const ewChangesValue = !isEmpty(ewChanges)
          ? ewChanges.map((date) => {
            const dateValue = date.operationHistoryStartDate
              ? moment(date.operationHistoryStartDate).format(dateFormat)
              : ""
            const count = date.CountOfoperationHistory
              ? date.CountOfoperationHistory
              : ""
            const separator = dateValue !== "" && count !== "" ? " - " : ""
            const result = `${dateValue}${separator}${count}`
            return dateValue !== "" || count !== "" ? result : "--"
          })
          : "--"

        const clientPending =
          data && !isEmpty(data.data) && data.data.length > 0
            ? data.data.filter(
              (data) => data.productioProcessStatusName == "CLIENT PENDING"
            )
            : []
        const clientPendingValue = !isEmpty(clientPending)
          ? clientPending.map((date) => {
            const dateValue = date.operationHistoryStartDate
              ? moment(date.operationHistoryStartDate).format(dateFormat)
              : ""
            const count = date.CountOfoperationHistory
              ? date.CountOfoperationHistory
              : ""
            const separator = dateValue !== "" && count !== "" ? " - " : ""
            const result = `${dateValue}${separator}${count}`
            return dateValue !== "" || count !== "" ? result : "--"
          })
          : "--"

        const qcRecheck =
          data && !isEmpty(data.data) && data.data.length > 0
            ? data.data.filter(
              (data) => data.productioProcessStatusName == "QC RECHECK"
            )
            : []
        const qcRecheckValue = !isEmpty(qcRecheck)
          ? qcRecheck.map((date) => {
            const dateValue = date.operationHistoryStartDate
              ? moment(date.operationHistoryStartDate).format(dateFormat)
              : ""
            const count = date.CountOfoperationHistory
              ? date.CountOfoperationHistory
              : ""
            const separator = dateValue !== "" && count !== "" ? " - " : ""
            const result = `${dateValue}${separator}${count}`
            return dateValue !== "" || count !== "" ? result : "--"
          })
          : "--"
        const onHold =
          data && !isEmpty(data.data) && data.data.length > 0
            ? data.data.filter(
              (data) => data.productioProcessStatusName == "ON HOLD"
            )
            : []
        const onHoldValue = !isEmpty(onHold)
          ? onHold.map((date) => {
            const dateValue = date.operationHistoryStartDate
              ? moment(date.operationHistoryStartDate).format(dateFormat)
              : ""
            const count = date.CountOfoperationHistory
              ? date.CountOfoperationHistory
              : ""
            const separator = dateValue !== "" && count !== "" ? " - " : ""
            const result = `${dateValue}${separator}${count}`
            return dateValue !== "" || count !== "" ? result : "--"
          })
          : "--"
        const notApplicable =
          data && !isEmpty(data.data) && data.data.length > 0
            ? data.data.filter(
              (data) => data.productioProcessStatusName == "NOT APPLICABLE"
            )
            : []
        const notApplicableValue = !isEmpty(notApplicable)
          ? notApplicable.map((date) => {
            const dateValue = date.operationHistoryStartDate
              ? moment(date.operationHistoryStartDate).format(dateFormat)
              : ""
            const count = date.CountOfoperationHistory
              ? date.CountOfoperationHistory
              : ""
            const separator = dateValue !== "" && count !== "" ? " - " : ""
            const result = `${dateValue}${separator}${count}`
            return dateValue !== "" || count !== "" ? result : "--"
          })
          : "--"
        //tab payload functionality
        const productIdValue =
          recordsMetaData && !isEmpty(recordsMetaData.productCategoryOptions)
            ? recordsMetaData.productCategoryOptions.find(
              (m) => m.label == data.productCategoryName
            ) &&
            recordsMetaData.productCategoryOptions.find(
              (m) => m.label == data.productCategoryName
            ).value
            : ""
        const plPendingIdValue =
          recordsMetaData && !isEmpty(recordsMetaData.deliverOptions)
            ? recordsMetaData.deliverOptions.find(
              (m) => m.label == "PL PENDING"
            ) &&
            recordsMetaData.deliverOptions.find(
              (m) => m.label == "PL PENDING"
            ).processStatusId
            : ""

        const plPendingDataValue = {
          processId: plPendingIdValue,
          productId: productIdValue,
          status: "PL PENDING",
        }
        const clientPendingIdValue =
          recordsMetaData && !isEmpty(recordsMetaData.deliverOptions)
            ? recordsMetaData.deliverOptions.find(
              (m) => m.label == "CLIENT PENDING"
            ) &&
            recordsMetaData.deliverOptions.find(
              (m) => m.label == "CLIENT PENDING"
            ).processStatusId
            : ""
        const clientPendingDataValue = {
          processId: clientPendingIdValue,
          productId: productIdValue,
          status: "CLIENT PENDING",
        }
        const EWPendingIdValue =
          recordsMetaData && !isEmpty(recordsMetaData.deliverOptions)
            ? recordsMetaData.deliverOptions.find(
              (m) => m.label == "EW PENDING"
            ) &&
            recordsMetaData.deliverOptions.find(
              (m) => m.label == "EW PENDING"
            ).processStatusId
            : ""
        const ewPendingDataValue = {
          processId: EWPendingIdValue,
          productId: productIdValue,
          status: "EW PENDING",
        }
        const ewQueueIdValue =
          recordsMetaData && !isEmpty(recordsMetaData.deliverOptions)
            ? recordsMetaData.deliverOptions.find(
              (m) => m.label == "EW QUEUE"
            ) &&
            recordsMetaData.deliverOptions.find(
              (m) => m.label == "EW QUEUE"
            ).processStatusId
            : ""
        const ewQueueDataValue = {
          processId: ewQueueIdValue,
          productId: productIdValue,
          status: "EW QUEUE",
          isPending: false,
        }

        const ewInProgessDataValue = {
          processId: ewQueueIdValue,
          productId: productIdValue,
          status: "EW INPROGRESS",
          isPending: true,
        }
        const ewCompletedId =
          recordsMetaData && !isEmpty(recordsMetaData.deliverOptions)
            ? recordsMetaData.deliverOptions.find(
              (m) => m.label == "EW COMPLETED"
            ) &&
            recordsMetaData.deliverOptions.find(
              (m) => m.label == "EW COMPLETED"
            ).processStatusId
            : ""
        const ewCompletedDataValue = {
          processId: ewCompletedId,
          productId: productIdValue,
          status: "EW COMPLETED",
        }
        const pendingToShareId =
          recordsMetaData && !isEmpty(recordsMetaData.deliverOptions)
            ? recordsMetaData.deliverOptions.find(
              (m) => m.label == "EW QC COMPLETED"
            ) &&
            recordsMetaData.deliverOptions.find(
              (m) => m.label == "EW QC COMPLETED"
            ).processStatusId
            : ""
        const pendingToShareDataValue = {
          processId: pendingToShareId,
          productId: productIdValue,
          status: "EW QC COMPLETED",
        }
        const ewReworkId =
          recordsMetaData && !isEmpty(recordsMetaData.deliverOptions)
            ? recordsMetaData.deliverOptions.find(
              (m) => m.label == "CLIENT REWORK"
            ) &&
            recordsMetaData.deliverOptions.find(
              (m) => m.label == "CLIENT REWORK"
            ).processStatusId
            : ""
        const ewReworkDataValue = {
          processId: ewReworkId,
          productId: productIdValue,
          status: "CLIENT REWORK",
        }
        const ewChangesId =
          recordsMetaData && !isEmpty(recordsMetaData.deliverOptions)
            ? recordsMetaData.deliverOptions.find(
              (m) => m.label == "CLIENT CHANGES"
            ) &&
            recordsMetaData.deliverOptions.find(
              (m) => m.label == "CLIENT CHANGES"
            ).processStatusId
            : ""
        // const ewChangesId = recordsMetaData && !isEmpty(recordsMetaData.deliverOptions) ?
        //     recordsMetaData.deliverOptions.find(m => m.label == "EW CHANGES") &&
        //     recordsMetaData.deliverOptions.find(m => m.label == "EW CHANGES").processStatusId : ""
        const ewChangesDataValue = {
          processId: ewChangesId,
          productId: productIdValue,
          status: "CLIENT CHANGES",
        }
        const qcRecheckId =
          recordsMetaData && !isEmpty(recordsMetaData.deliverOptions)
            ? recordsMetaData.deliverOptions.find(
              (m) => m.label == "QC RECHECK"
            ) &&
            recordsMetaData.deliverOptions.find(
              (m) => m.label == "QC RECHECK"
            ).processStatusId
            : ""
        const qcRecheckDataValue = {
          processId: qcRecheckId,
          productId: productIdValue,
          status: "QC RECHECK",
        }
        const onHoldId =
          recordsMetaData && !isEmpty(recordsMetaData.deliverOptions)
            ? recordsMetaData.deliverOptions.find(
              (m) => m.label == "ON HOLD"
            ) &&
            recordsMetaData.deliverOptions.find((m) => m.label == "ON HOLD")
              .processStatusId
            : ""
        const onHoldDataValue = {
          processId: onHoldId,
          productId: productIdValue,
          status: "ON HOLD",
        }
        const notApplicableId =
          recordsMetaData && !isEmpty(recordsMetaData.deliverOptions)
            ? recordsMetaData.deliverOptions.find(
              (m) => m.label == "NOT APPLICABLE"
            ) &&
            recordsMetaData.deliverOptions.find(
              (m) => m.label == "NOT APPLICABLE"
            ).processStatusId
            : ""
        const notApplicableDataValue = {
          processId: notApplicableId,
          productId: productIdValue,
          status: "NOT APPLICABLE",
        }
        return {
          _id: index,
          sNo: index + 1,
          productList: data.productCategoryName,
          PLPending: plPendingValue,
          clientPending: clientPendingValue,
          EWPending: ewPendingValue,
          EWQueue: ewQueueValue,
          EWQueueSub: ewInProgressValue,
          EWCompleted: ewCompletedValue,
          pendingToShare: pendingToShareValue,
          ewRework: ewReworkValue,
          ewChanges: ewChangesValue,
          qcRecheck: qcRecheckValue,
          onHold: onHoldValue,
          notApplicable: notApplicableValue,
          //payload data
          plPendingData: plPendingDataValue,
          clientPendingData: clientPendingDataValue,
          ewPendingData: ewPendingDataValue,
          ewQueueData: ewQueueDataValue,
          ewInProgressData: ewInProgessDataValue,
          ewCompletedData: ewCompletedDataValue,
          pendingToShareData: pendingToShareDataValue,
          ewReworkData: ewReworkDataValue,
          ewChangesData: ewChangesDataValue,
          qcRecheckData: qcRecheckDataValue,
          onHoldData: onHoldDataValue,
          notApplicableData: notApplicableDataValue,
        }
      })
      : []
  const handleClickTab = (tableData) => {
    console.log("handleClickTab called with tableData:", tableData)
    const statusName = tableData.status
    const statusDetails = {
      productCategoryId: tableData.productId,
      productionProcessStatus: tableData.processId,
      isPending: tableData.isPending,
    }
    if (searchValue.CRMEmpId) {
      statusDetails.CRMEmpId = searchValue.CRMEmpId
    }
    if (searchValue.eventFromDate) {
      statusDetails.eventFromDate = searchValue.eventFromDate
    }
    if (searchValue.eventToDate) {
      statusDetails.eventToDate = searchValue.eventToDate
    }
    console.log("statusDetails:", statusDetails)


    api
      .post(`/get_Production_Deliverable_processStatus_new`, statusDetails)
      .then((response) => {
        const statusData = !isEmpty(response.data.data) ? response.data.data : []
        setTimeout(() => {
          // Use the current value of statusData, which should be updated due to the useEffect
          console.log("statusData in setTimeout:", statusData)
          const newTab = window.open("", "_blank", "width=600,height=400")
          if (newTab) {
            const container = newTab.document.createElement("div")
            newTab.document.body.appendChild(container)
            ReactDOM.render(
              <ProductAgingTableComponent
                data={statusData} // Use statusData directly here
                dispatch={dispatch}
                statusPayload={statusDetails}
                name={statusName}
                dateFormat={dateFormat}
                searchBtnStyle ={searchBtnStyle}
              />,
              container
            )
            newTab.document.title = "PRODUCT-STATUS-AGING-REPORT"
          }
        }, 2000)
      })
      .catch((error) => {
        Promise.reject(error)
        const newTab = window.open("", "_blank", "width=600,height=400")
        if (newTab) {
          const container = newTab.document.createElement("div")
          newTab.document.body.appendChild(container)
          ReactDOM.render(
            <ProductAgingTableComponent
              data={[]} // Use statusData directly here
              dispatch={dispatch}
              statusPayload={statusDetails}
              name={statusName}
              dateFormat={dateFormat}
            />,
            container
          )
          newTab.document.title = "PRODUCT-STATUS-AGING-REPORT"
        }
      })

  }

  const columns = [
   
    {
      dataField: "productList",
      text: "Product List",
      csvExport: false,
      headerStyle: {
        minWidth: "170px",
        position: "sticky",
        left: 0,
        backgroundColor: "#F8F8FB",
        zIndex: 1,
      },
      formatter: (cellContent, row) => {
        return (
          <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
            {row.productList}
          </div>
        )
      
      },
      style: {
        position: "sticky",
        left:0,
        backgroundColor: "#F8F8FB",
        zIndex: 1,
    },
    },
    {
      dataField: "PLPending",
      text: "PL PENDING",
      csvExport: false,
      headerStyle: {
        minWidth: "170px",
      },
      formatter: (cellContent, row) => {
        const tableData = row.plPendingData

        return cellContent !== "--" ? (
          <div
            style={{
              fontWeight: "bold",
              color: "#e40d8c",
              fontSize: "14px",
              textDecoration: "underline",
            }}
            onClick={() => handleClickTab(tableData)}
          >
            {cellContent}
          </div>
        ) : (
          <div>{cellContent}</div>
        )
      },
    },
    {
      dataField: "clientPending",
      text: "CLIENT PENDING",
      csvExport: false,
      headerStyle: {
        minWidth: "170px",
      },
      formatter: (cellContent, row) => {
        const tableData = row.clientPendingData
        return row.clientPending != "--" ? (
          <div
            style={{
              fontWeight: "bold",
              color: "#e40d8c",
              fontSize: "14px",
              textDecoration: "underline",
            }}
            onClick={() => handleClickTab(tableData)}
          >
            {cellContent}
          </div>
        ) : (
          <div>{cellContent}</div>
        )
      },
    },

    {
      dataField: "EWPending",
      text: "EW PENDING",
      csvExport: false,
      headerStyle: {
        minWidth: "170px",
      },
      formatter: (cellContent, row) => {
        const tableData = row.ewPendingData
        return cellContent != "--" ? (
          <div
            style={{
              fontWeight: "bold",
              color: "#e40d8c",
              fontSize: "14px",
              textDecoration: "underline",
            }}
            onClick={() => handleClickTab(tableData)}
          >
            {cellContent}
          </div>
        ) : (
          <div>{cellContent}</div>
        )
      },
    },
    {
      dataField: "EWQueue",
      text: "EW QUEUE",
      csvExport: false,
      headerStyle: {
        minWidth: "170px",
      },
      formatter: (cellContent, row) => {
        const tableData = row.ewQueueData
        return cellContent != "--" ? (
          <div
            style={{
              fontWeight: "bold",
              color: "#e40d8c",
              fontSize: "14px",
              textDecoration: "underline",
            }}
            onClick={() => handleClickTab(tableData)}
          >
            {cellContent}
          </div>
        ) : (
          <div>{cellContent}</div>
        )
      },
    },
    {
      dataField: "EWQueueSub",
      text: "EW INPROGRESS",
      csvExport: false,
      headerStyle: {
        minWidth: "170px",
      },
      formatter: (cellContent, row) => {
        const tableData = row.ewInProgressData
        return cellContent != "--" ? (
          <div
            style={{
              fontWeight: "bold",
              color: "#e40d8c",
              fontSize: "14px",
              textDecoration: "underline",
            }}
            onClick={() => handleClickTab(tableData)}
          >
            {cellContent}
          </div>
        ) : (
          <div>{cellContent}</div>
        )
      },
    },
    {
      dataField: "EWCompleted",
      text: "EW COMPLETED",
      csvExport: false,
      headerStyle: {
        minWidth: "170px",
      },
      formatter: (cellContent, row) => {
        const tableData = row.ewCompletedData
        return cellContent != "--" ? (
          <div
            style={{
              fontWeight: "bold",
              color: "#e40d8c",
              fontSize: "14px",
              textDecoration: "underline",
            }}
            onClick={() => handleClickTab(tableData)}
          >
            {cellContent}
          </div>
        ) : (
          <div>{cellContent}</div>
        )
      },
    }, //SHARED TO CLIENT

    {
      dataField: "pendingToShare",
      text: "PENDING TO SHARE",
      csvExport: false,
      headerStyle: {
        minWidth: "170px",
      },
      formatter: (cellContent, row) => {
        const tableData = row.pendingToShareData
        return cellContent != "--" ? (
          <div
            style={{
              fontWeight: "bold",
              color: "#e40d8c",
              fontSize: "14px",
              textDecoration: "underline",
            }}
            onClick={() => handleClickTab(tableData)}
          >
            {cellContent}
          </div>
        ) : (
          <div>{cellContent}</div>
        )
      },
    },

    {
      dataField: "qcRecheck",
      text: "QC RECHECK",
      csvExport: false,
      headerStyle: {
        minWidth: "170px",
      },
      formatter: (cellContent, row) => {
        const tableData = row.qcRecheckData
        return cellContent != "--" ? (
          <div
            style={{
              fontWeight: "bold",
              color: "#e40d8c",
              fontSize: "14px",
              textDecoration: "underline",
            }}
            onClick={() => handleClickTab(tableData)}
          >
            {cellContent}
          </div>
        ) : (
          <div>{cellContent}</div>
        )
      },
    },
    {
      dataField: "onHold",
      text: "ON HOLD",
      csvExport: false,
      headerStyle: {
        minWidth: "170px",
      },
      formatter: (cellContent, row) => {
        const tableData = row.onHoldData
        return cellContent != "--" ? (
          <div
            style={{
              fontWeight: "bold",
              color: "#e40d8c",
              fontSize: "14px",
              textDecoration: "underline",
            }}
            onClick={() => handleClickTab(tableData)}
          >
            {cellContent}
          </div>
        ) : (
          <div>{cellContent}</div>
        )
      },
    },

    {
      dataField: "ewChanges",
      text: "CLIENT CHANGES",
      csvExport: false,
      headerStyle: {
        minWidth: "170px",
      },
      formatter: (cellContent, row) => {
        const tableData = row.ewChangesData
        return cellContent != "--" ? (
          <div
            style={{
              fontWeight: "bold",
              color: "#e40d8c",
              fontSize: "14px",
              textDecoration: "underline",
            }}
            onClick={() => handleClickTab(tableData)}
          >
            {cellContent}
          </div>
        ) : (
          <div>{cellContent}</div>
        )
      },
    },
    {
      dataField: "ewRework",
      text: "CLIENT REWORK",
      csvExport: false,
      headerStyle: {
        minWidth: "170px",
      },
      formatter: (cellContent, row) => {
        const tableData = row.ewReworkData
        return cellContent != "--" ? (
          <div
            style={{
              fontWeight: "bold",
              color: "#e40d8c",
              fontSize: "14px",
              textDecoration: "underline",
            }}
            onClick={() => handleClickTab(tableData)}
          >
            {cellContent}
          </div>
        ) : (
          <div>{cellContent}</div>
        )
      },
    },
    {
      dataField: "notApplicable",
      text: "NOT APPLICABLE",
      csvExport: false,
      headerStyle: {
        minWidth: "170px",
      },
      formatter: (cellContent, row) => {
        const tableData = row.notApplicableData
        return cellContent != "--" ? (
          <div
            style={{
              fontWeight: "bold",
              color: "#e40d8c",
              fontSize: "14px",
              textDecoration: "underline",
            }}
            onClick={() => handleClickTab(tableData)}
          >
            {cellContent}
          </div>
        ) : (
          <div>{cellContent}</div>
        )
      },
    },
  ]

  const options = {
    sizePerPage: 50,
    totalSize: product_data.length,
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      productAction.loadProductStatus({
        searchFilter: searchInput,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchEmployee = employee && employee ? employees : ""
    var searchProduct =
      !isEmpty(productCategory) && productCategory ? products : ""
    var searchFromDate =
      productStatusData && productStatusData.eventFromDate
        ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      productStatusData && productStatusData.eventToDate
        ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}

    if (searchProduct) {
      searchvalue.ProductCategoryId = searchProduct
    }
    if (searchEmployee) {
      searchvalue.CRMEmpId = searchEmployee
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }

    setDownloadLoading(true)

    api
      .post(`/get_Product_ProcessStatus_age_report`, searchvalue)
      .then((response) => {
        const photoExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
            const PLPending =
              data && !isEmpty(data.data) && data.data.length > 0
                ? data.data.filter(
                  (data) => data.productioProcessStatusName == "PENDING PL"
                )
                : []
            const plPendingValue = !isEmpty(PLPending)
              ? PLPending.map((date) => {
                const dateValue = date.assignCrmEmployeeStartDate
                  ? moment(date.assignCrmEmployeeStartDate).format(
                    dateFormat
                  )
                  : ""
                const count = date.CountOfassignCrmEmployeeDate
                  ? date.CountOfassignCrmEmployeeDate
                  : ""
                const separator =
                  dateValue !== "" && count !== "" ? " - " : ""
                const result = `${dateValue}${separator}${count}`
                return dateValue !== "" || count !== "" ? result : "--"
              })
              : ""

            const EWPending =
              data && !isEmpty(data.data) && data.data.length > 0
                ? data.data.filter(
                  (data) => data.productioProcessStatusName == "EW PENDING"
                )
                : []
            const ewPendingValue = !isEmpty(EWPending)
              ? EWPending.map((date) => {
                const dateValue = date.assignedTeamleadStartDate
                  ? moment(date.assignedTeamleadStartDate).format(
                    dateFormat
                  )
                  : ""
                const count = date.CountOfassignedTeamleadDate
                  ? date.CountOfassignedTeamleadDate
                  : ""
                const separator =
                  dateValue !== "" && count !== "" ? " - " : ""
                const result = `${dateValue}${separator}${count}`
                return dateValue !== "" || count !== "" ? result : "--"
              })
              : ""

            const EWQueue =
              data && !isEmpty(data.data) && data.data.length > 0
                ? data.data.filter(
                  (data) => data.productioProcessStatusName == "EW QUEUE"
                )
                : []
            const ewQueueValue = !isEmpty(EWQueue)
              ? EWQueue.map((date) => {
                const dateValue = date.assignEmployeeStartDate
                  ? moment(date.assignEmployeeStartDate).format(dateFormat)
                  : ""
                const count = date.CountOfAssignEmployeeDate
                  ? date.CountOfAssignEmployeeDate
                  : ""
                const separator =
                  dateValue !== "" && count !== "" ? " - " : ""
                const result = `${dateValue}${separator}${count}`
                return dateValue !== "" || count !== "" ? result : "--"
              })
              : ""

            const EWInprogress =
              data && !isEmpty(data.data) && data.data.length > 0
                ? data.data.filter(
                  (data) =>
                    data.productioProcessStatusName == "EW INPROGRESS"
                )
                : []
            const ewInProgressValue = !isEmpty(EWInprogress)
              ? EWInprogress.map((date) => {
                const dateValue = date.subStatusStartDate
                  ? moment(date.subStatusStartDate).format(dateFormat)
                  : ""
                const count = date.CountOfsubStatuseDate
                  ? date.CountOfsubStatuseDate
                  : ""
                const separator =
                  dateValue !== "" && count !== "" ? " - " : ""
                const result = `${dateValue}${separator}${count}`
                return dateValue !== "" || count !== "" ? result : "--"
              })
              : ""

            const EWCompleted =
              data && !isEmpty(data.data) && data.data.length > 0
                ? data.data.filter(
                  (data) =>
                    data.productioProcessStatusName == "EW COMPLETED"
                )
                : []
            const ewCompletedValue = !isEmpty(EWCompleted)
              ? EWCompleted.map((date) => {
                const dateValue = date.operationHistoryStartDate
                  ? moment(date.operationHistoryStartDate).format(
                    dateFormat
                  )
                  : ""
                const count = date.CountOfoperationHistory
                  ? date.CountOfoperationHistory
                  : ""
                const separator =
                  dateValue !== "" && count !== "" ? " - " : ""
                const result = `${dateValue}${separator}${count}`
                return dateValue !== "" || count !== "" ? result : "--"
              })
              : ""

            const pendingToShare =
              data && !isEmpty(data.data) && data.data.length > 0
                ? data.data.filter(
                  (data) =>
                    data.productioProcessStatusName == "EW QC COMPLETED"
                )
                : []
            const pendingToShareValue = !isEmpty(pendingToShare)
              ? pendingToShare.map((date) => {
                const dateValue = date.operationHistoryStartDate
                  ? moment(date.operationHistoryStartDate).format(
                    dateFormat
                  )
                  : ""
                const count = date.CountOfoperationHistory
                  ? date.CountOfoperationHistory
                  : ""
                const separator =
                  dateValue !== "" && count !== "" ? " - " : ""
                const result = `${dateValue}${separator}${count}`
                return dateValue !== "" || count !== "" ? result : "--"
              })
              : ""

            const ewRework =
              data && !isEmpty(data.data) && data.data.length > 0
                ? data.data.filter(
                  (data) =>
                    data.productioProcessStatusName == "CLIENT REWORK"
                )
                : []
            const ewReworkValue = !isEmpty(ewRework)
              ? ewRework.map((date) => {
                const dateValue = date.operationHistoryStartDate
                  ? moment(date.operationHistoryStartDate).format(
                    dateFormat
                  )
                  : ""
                const count = date.CountOfoperationHistory
                  ? date.CountOfoperationHistory
                  : ""
                const separator =
                  dateValue !== "" && count !== "" ? " - " : ""
                const result = `${dateValue}${separator}${count}`
                return dateValue !== "" || count !== "" ? result : "--"
              })
              : "--"

            const ewChanges =
              data && !isEmpty(data.data) && data.data.length > 0
                ? data.data.filter(
                  (data) =>
                    data.productioProcessStatusName == "CLIENT CHANGES"
                )
                : []
            const ewChangesValue = !isEmpty(ewChanges)
              ? ewChanges.map((date) => {
                const dateValue = date.operationHistoryStartDate
                  ? moment(date.operationHistoryStartDate).format(
                    dateFormat
                  )
                  : ""
                const count = date.CountOfoperationHistory
                  ? date.CountOfoperationHistory
                  : ""
                const separator =
                  dateValue !== "" && count !== "" ? " - " : ""
                const result = `${dateValue}${separator}${count}`
                return dateValue !== "" || count !== "" ? result : "--"
              })
              : "--"

            const clientPending =
              data && !isEmpty(data.data) && data.data.length > 0
                ? data.data.filter(
                  (data) =>
                    data.productioProcessStatusName == "CLIENT PENDING"
                )
                : []
            const clientPendingValue = !isEmpty(clientPending)
              ? clientPending.map((date) => {
                const dateValue = date.operationHistoryStartDate
                  ? moment(date.operationHistoryStartDate).format(
                    dateFormat
                  )
                  : ""
                const count = date.CountOfoperationHistory
                  ? date.CountOfoperationHistory
                  : ""
                const separator =
                  dateValue !== "" && count !== "" ? " - " : ""
                const result = `${dateValue}${separator}${count}`
                return dateValue !== "" || count !== "" ? result : "--"
              })
              : ""
            const qcRecheck =
              data && !isEmpty(data.data) && data.data.length > 0
                ? data.data.filter(
                  (data) => data.productioProcessStatusName == "QC RECHECK"
                )
                : []
            const qcRecheckValue = !isEmpty(qcRecheck)
              ? qcRecheck.map((date) => {
                const dateValue = date.operationHistoryStartDate
                  ? moment(date.operationHistoryStartDate).format(
                    dateFormat
                  )
                  : ""
                const count = date.CountOfoperationHistory
                  ? date.CountOfoperationHistory
                  : ""
                const separator =
                  dateValue !== "" && count !== "" ? " - " : ""
                const result = `${dateValue}${separator}${count}`
                return dateValue !== "" || count !== "" ? result : "--"
              })
              : ""
            const onHold =
              data && !isEmpty(data.data) && data.data.length > 0
                ? data.data.filter(
                  (data) => data.productioProcessStatusName == "ON HOLD"
                )
                : []
            const onHoldValue = !isEmpty(onHold)
              ? onHold.map((date) => {
                const dateValue = date.operationHistoryStartDate
                  ? moment(date.operationHistoryStartDate).format(
                    dateFormat
                  )
                  : ""
                const count = date.CountOfoperationHistory
                  ? date.CountOfoperationHistory
                  : ""
                const separator =
                  dateValue !== "" && count !== "" ? " - " : ""
                const result = `${dateValue}${separator}${count}`
                return dateValue !== "" || count !== "" ? result : "--"
              })
              : ""
            const notApplicable =
              data && !isEmpty(data.data) && data.data.length > 0
                ? data.data.filter(
                  (data) =>
                    data.productioProcessStatusName == "NOT APPLICABLE"
                )
                : []
            const notApplicableValue = !isEmpty(notApplicable)
              ? notApplicable.map((date) => {
                const dateValue = date.operationHistoryStartDate
                  ? moment(date.operationHistoryStartDate).format(
                    dateFormat
                  )
                  : ""
                const count = date.CountOfoperationHistory
                  ? date.CountOfoperationHistory
                  : ""
                const separator =
                  dateValue !== "" && count !== "" ? " - " : ""
                const result = `${dateValue}${separator}${count}`
                return dateValue !== "" || count !== "" ? result : "--"
              })
              : ""
            return {
              _id: index,
              sNo: index + 1,
              productList: data.productCategoryName,
              PLPending: plPendingValue,
              clientPending: clientPendingValue,
              EWPending: ewPendingValue,
              EWQueue: ewQueueValue,
              EWQueueSub: ewInProgressValue,
              EWCompleted: ewCompletedValue,
              pendingToShare: pendingToShareValue,
              ewRework: ewReworkValue,
              ewChanges: ewChangesValue,
              qcRecheck: qcRecheckValue,
              onHold: onHoldValue,
              notApplicable: notApplicableValue,
            }
          })
          : []
        setTimeout(() => {
          let headerData = [
            "S.No,Product List,PL Pending, Client Pending, EW Pending, EW Queue,EW INProgress, EW Completed,Pending To Share,Qc Recheck,On Hold,Client Changes,Client Rework,Not Applicable",
          ]

          // Add total row to the data

          let usersCsv =
            !isEmpty(photoExportDataTable) &&
            photoExportDataTable.reduce((acc, user) => {
              const {
                sNo,
                productList,
                PLPending,
                clientPending,
                EWPending,
                EWQueue,
                EWQueueSub,
                EWCompleted,
                pendingToShare,
                qcRecheck,
                onHold,
                ewChanges,
                ewRework,
                notApplicable,
              } = user
              acc.push([
                sNo,
                productList,
                PLPending,
                clientPending,
                EWPending,
                EWQueue,
                EWQueueSub,
                EWCompleted,
                pendingToShare,
                qcRecheck,
                onHold,
                ewChanges,
                ewRework,
                notApplicable,
              ])

              return acc
            }, [])

          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "ProductStatusAgingReport.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1000)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
  }
  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Product Category"}
                        >
                          {"Product Category"}
                        </Label>
                      </div>

                      <MultiSelect
                        options={productCategoryOptions}
                        value={productCategory}
                        onChange={setProductCategory}
                        labelledBy="Select"
                        hasSelectAll={true}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">CRM Employee</Label>
                      <Select
                        type="text"
                        name="employee"
                        isMulti
                        value={employee}
                        onChange={(e) => setEmployee(e)}
                        options={
                          recordsMetaData ? recordsMetaData.employeeOptions : []
                        }
                        placeholder="Select CRM Employee"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event From Date"}
                        >
                          {"Event From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventFromDate"
                        value={productStatusData.eventFromDate}
                        max={productStatusData.eventToDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event To Date"}
                        >
                          {"Event To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventToDate"
                        value={productStatusData.eventToDate}
                        min={productStatusData.eventFromDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                          onClick={() => {
                            resetForm()
                          }}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => handleFilter(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                    <form onSubmit={handleClick} className="d-flex flex-row">
                      <div style={searchBtnStyle || null}>
                        <Input
                          type="text"
                          name="searchInput"
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                          className="form-control"
                          placeholder="Search"
                          style={{ position: "relative" }}
                        />
                        <i
                          className="bx bx-search-alt"
                          style={{
                            position: "absolute",
                            top: "54px",
                            left: "41px",
                            fontSize: "13px",
                          }}
                        />
                      </div>

                      <button
                        className="btn btn-success mx-2"
                        type="submit"
                        style={{
                          background: searchFilter ? "#2ca67a" : "",
                          color: searchFilter ? "#ffffff" : "",
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </form>
                  </div>
                </div>
                <Row>
                  <Col md="4" lg="4" sm="12"></Col>
                  <Col
                    md="8"
                    lg="8"
                    sm="12"
                    style={{ marginBottom: "20px", marginTop: "-41px" }}
                  >
                    <div
                      style={{
                        float: "right",
                      }}
                    >
                      <Button
                        className="btn btn-primary"
                        onClick={exportToCsv}
                        id="download"
                        style={{
                          backgroundColor: "#e40d8c",
                          color: "white",
                          border: "none",
                        }}
                      >
                        Download
                      </Button>
                    </div>
                  </Col>
                </Row>

                <Col md="12" lg="12" xl="12" className="mt-3">
                  <PaginationProvider pagination={paginationFactory(options)}>
                    {({ paginationProps, paginationTableProps }) => (
                      <div>
                        <Col md="12" xl="12" lg="12" sm="12" xs="12">
                          <Row className="d-flex flex-row  ">
                            <Col style={{ overflowX: "auto", width: "100%" }}>
                              <BootstrapTable
                                data={productStatusTable}
                                bordered={true}
                                noDataIndication={"No Data Found..."}
                                keyField="_id"
                                columns={columns}
                                {...paginationTableProps}
                              />
                            </Col>
                          </Row>
                          <Row
                            style={{ marginTop: "5px" }}
                            className="align-items-md-center mt-30"
                          >
                            <Col className="inner-custom-pagination d-flex">
                              <div className="d-inline d-flex flex-row">
                                <SizePerPageDropdownStandalone
                                  {...paginationProps}
                                />
                                <div
                                  style={{
                                    fontSize: "14px",
                                    marginTop: "8px",
                                    marginLeft: "4px",
                                  }}
                                >
                                  <PaginationTotalStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </div>
                              <div
                                className="text-md-right ms-auto"
                                style={{ zIndex: 0 }}
                              >
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </div>
                    )}
                  </PaginationProvider>
                </Col>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {downloadLoading ? (
        <Modal
          show={downloadLoading}
          style={{ width: "7%", margin: "18% 50%" }}
        >
          <Modal.Body>
            <Spinner
              as="span"
              animation="grow"
              size="lg"
              role="status"
              aria-hidden="true"
              variant="success"
              className="mx-2"
              color="success"
            />
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )}
    </div>
  )
}
ProductStatusAgingReport.propTypes = {
  dispatch: PropTypes.func,
  searchBtnStyle: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,ProductStatusAgingReport
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductStatusAgingReport)
)
